import React, { useState } from "react";

const EMPTY_FORM = { name: "", email: "", reason: "", message: "" };

export default function ContactForm() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [sent, setSent] = useState(false);

  const updateField = (field) => (e) => {
    setForm((f) => ({ ...f, [field]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setForm(EMPTY_FORM);
    setTimeout(() => setSent(false), 2500);
  };

  return (
    <section className="mu-section">
      <div className="container">
        <div className="contact-form-card">
          <h5 className="mb-4">Send Us a Message</h5>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-field-label">Full Name</label>
                <input
                  type="text"
                  className="form-field-input"
                  placeholder="Jane Doe"
                  value={form.name}
                  onChange={updateField("name")}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-field-label">Email Address</label>
                <input
                  type="email"
                  className="form-field-input"
                  placeholder="jane@email.com"
                  value={form.email}
                  onChange={updateField("email")}
                  required
                />
              </div>
              <div className="col-12">
                <label className="form-field-label">Reason for Contact</label>
                <input
                  type="text"
                  className="form-field-input"
                  placeholder="General Inquiry / Partnership / Support / Press"
                  value={form.reason}
                  onChange={updateField("reason")}
                />
              </div>
              <div className="col-12">
                <label className="form-field-label">Message</label>
                <textarea
                  className="form-field-input"
                  rows={5}
                  placeholder="Tell us how we can help..."
                  value={form.message}
                  onChange={updateField("message")}
                  required
                />
              </div>
            </div>

            <button type="submit" className="btn-mu-solid mt-3" style={{ width: "auto" }}>
              {sent ? "✓ Message Sent" : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
